import { usePunditUserContext } from "@/react/contexts";
import {
  isTrialBannerVariantACookieSet,
  isTrialBannerVariantBCookieSet,
} from "@/react/utils/isCookieSet";
import { useExperimentEnabled } from "./useExperimentEnabled";

const TEST_FLAG = "trial_banner_variants_test";
const VARIANT_A = "variant_A";
const VARIANT_B = "variant_B";
const CONTROL = "control";

interface TrialBannerState {
  isTestVariant: boolean;
  isVariantA: boolean;
  isVariantB: boolean;
}

export const useTrialBannerVariant = (): TrialBannerState => {
  const isEnabled = useExperimentEnabled(TEST_FLAG);
  const { experimentation } = usePunditUserContext();
  const activeVariant = isEnabled
    ? experimentation?.flags?.[TEST_FLAG]
    : CONTROL;

  const isVariantACookie = isTrialBannerVariantACookieSet();
  const isVariantBCookie = isTrialBannerVariantBCookieSet();
  const isVariantA = isVariantACookie || activeVariant === VARIANT_A;
  const isVariantB = isVariantBCookie || activeVariant === VARIANT_B;

  return {
    isVariantA,
    isVariantB,
    isTestVariant: isVariantA || isVariantB,
  };
};
